/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesProject_Projects.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Project Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Saturday, June 15, 2019 - 01:06:32 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      06/15/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const Project_ProjectList = Loadable({
    loader: () => import('../containers/Project_Projects/Project_ProjectListContainer'),
    loading: Loading,
});

export const Project_ProjectForm = Loadable({
    loader: () => import('../containers/Project_Projects/Project_ProjectEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesProject_Projects.js